import React, {Component} from  "react";
import {connect} from 'react-redux';
import cookie from "react-cookies";
import axios from "axios";
import { AuthHeader } from "../../../../helper/auth.token";
import {Row, Col, Switch, Divider, message, Spin, Radio} from 'antd';
import { Fill, Stroke, Style } from 'ol/style.js';
import { Vector as VectorSource } from 'ol/source.js';
import { Vector as VectorLayer } from 'ol/layer.js';
import {click} from 'ol/events/condition.js';
import Select from 'ol/interaction/Select.js';
import { updateAppClosedStatus } from '../../../../action/morpheus.state.action'
import { getDrawingTools } from './drawing/draw_tool_maker'
import { getAnnotationList, addAnnotation, drawAnnotations, getAnnotationsInListView, getAnnotationsInGridView } from './annotations_app_utils'

import "../../../../asset/style/neoviewer/annotations_app.css"

class AbstractAnnotator extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedTool: null,
            continuousMode: false, 
            isFetching: false, 
            isDrawing: false,
            annotations: [], 
            busyMessage: "...", 
            selectedAnnotationId: null,
            gridView: false,
            imgsPerColInGridView: 3
        }
        
        this.timer = null;
        this.vector = new VectorLayer({
            source: new VectorSource({})
        });
        this.vector.set('annotationLayer', true);
        this.selectHover = new Select({
            condition: click, 
            layers: [this.vector], 
            wrapX: false,
            hitTolerance: 5,
            style: new Style({
                stroke: new Stroke({
                    color: 'rgba(0, 0, 0, 0.0)',
                }),
                fill: new Fill({
                    color: 'rgba(0, 0, 0, 0.0)'
                })
            })
        });
    }

    onSelected = (newSelection) => {
        let newTool = newSelection === this.state.selectedTool ? null : newSelection;
        this.setState({
            selectedTool: newTool
        })
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        if (nextState.isDrawing) return false;
        return true;
    }

    setDrawing = (value) => {

        if (value) {
            this.removeSelectInteraction();
        } else if (!this.state.continuousMode) {
            this.onSelected(null);
            this.addSelectInteraction();
        }

        this.setState({isDrawing: value});
    }
    
    redrawAnnotations = () => drawAnnotations(this.vector, this.state.annotations, this.state.selectedAnnotationId);

    removeSelectInteraction = () => {
        this.props.slidemap.removeInteraction(this.selectHover);
    }

    changeSelectedAnnotation = (selectedId) => {    
        this.setState({
            selectedAnnotationId: selectedId
        }, this.redrawAnnotations)
    }

    addSelectInteraction = () => {
        this.props.slidemap.addInteraction(this.selectHover);
        this.selectHover.on("select", e => {
            let selectedFeature = undefined;
            if (e.deselected.length > 0) {
                if (e.selected.length > 0) {
                    if (e.selected[0].getId() !== e.deselected[0].getId() || e.selected[0].getId() != this.state.selectedAnnotationId) {
                        selectedFeature = e.selected[0];
                    } 
                }
            } else if (e.selected.length > 0) {
                selectedFeature = e.selected[0];
            }
            // if (selectedFeature.getProperties().creator != this.props.creator) selectedFeature = undefined;
            if (selectedFeature != undefined) {
                this.changeSelectedAnnotation(selectedFeature.getId());
                if (this.props.openAppOnAnnoClick && this.props.urlState.app_state[this.props.id].closed) {
                    this.props.dispatch(updateAppClosedStatus(this.props.id, false));
                }
            } else {
                this.selectHover.getFeatures().clear();
                this.setState({
                    selectedAnnotationId: null
                }, this.redrawAnnotations);
            }
        });
    }

    componentWillMount = () => {
        this.props.slidemap.addLayer(this.vector);
        this.addSelectInteraction();
    }

    escFunction = (event) => {
        if(event.keyCode === 27) {
            this.selectHover.getFeatures().clear();
            this.setState({
                selectedAnnotationId: null
            }, this.redrawAnnotations)
        }
    }

    doRefreshAnnotationsFromBackend = () => getAnnotationList(this.props.slide.id, this.props.creator, (annotations) => {
        this.setState({
            annotations
        }, this.redrawAnnotations);
    })

    componentDidMount = () => {
        this.doRefreshAnnotationsFromBackend();
        this.timer = setInterval(this.doRefreshAnnotationsFromBackend, 2000);
        document.addEventListener("keydown", this.escFunction, false);
    }

    componentWillUnmount = () => clearTimeout(this.timer);

    switchContinuousMode = (value) => {
        this.setState({
            continuousMode: value, 
            selectedTool: (value) ? this.state.selectedTool : null
        }, () => this.setDrawing(false));
    }

    switchGridView = (e) => {
        this.setState({
            gridView: e.target.value == 1
        })
    }

    onChangeImgsPerColInGridView = (val) => {
        this.setState({
            imgsPerColInGridView: val
        })
    }

    onSelectAnnotationFromList = (annotation) => {
        let selectedFeature = this.vector.getSource().getFeatures().find((feature) => {
            return feature.getId() == annotation.id;
        });
        this.props.slidemap.getView().fit(selectedFeature.getGeometry());
        this.setState({
            selectedAnnotationId: annotation.id
        }, this.redrawAnnotations);
    }

    onDeleteAnnotation = (e, id) => {
        this.setState({
            isFetching: true, 
        })
        let url = `/api/annotation/${id}/ `;
        axios.delete(url, { headers: { Authorization: AuthHeader() } })
        .then(response => {
            if (response.status === 204 || response.status === 200 || response.status === 301 || response.status === 302) {
                let features = this.vector.getSource().getFeatures();
                let result = features.filter(index => index.getId() === id);
                this.vector.getSource().removeFeature(result[0]);
                let currentAnnotations = this.state.annotations;
                for (let i = 0; i < currentAnnotations.length; i++) {
                    if (currentAnnotations[i].id == id) {
                        currentAnnotations.splice(i, 1);
                        break;
                    }
                }
                this.setState({
                    annotations: currentAnnotations,
                    selectedAnnotationId: (this.state.selectedAnnotationId == id) ? null : this.state.selectedAnnotationId
                }, this.redrawAnnotations)
            }
            else if (response.status === 403 || response.status === 401 || response.status === 400) {
                message.error('Annotation Delete Failed', 2.5);
            }
            this.setState({
                isFetching: false
            })
        })
        .catch(err => {
            this.setState({
                isFetching: false
            })
        });
        e.stopPropagation();
    }

    render(){

        let currentAnnotations = this.state.annotations;

        let drawToolParams = {
            slidemap: this.props.slidemap,
            vector: this.vector, 
            onSelected: this.onSelected, 
            currentSelectedKey: this.state.selectedTool, 
            continuousMode: this.state.continuousMode,
            setDrawing: this.setDrawing, 
            addSelectInteraction: this.addSelectInteraction, 
            removeSelectInteraction: this.removeSelectInteraction, 
            addAnnotation: (area, perimeter, key, coord, center) => {
                addAnnotation(area, perimeter, key, coord, center, this.props.creator, this.props.urlState.z, this.props.slide.id, this.doRefreshAnnotationsFromBackend);
            }
        }

        let drawingTools = getDrawingTools(drawToolParams, this.props.drawToolKeys);

        let colSpan = 24 / drawingTools.length;

        let annotationsDiv;
        
        if (this.props.annotationsViewCreator == undefined) { // Use Default View if not supplied a function
            if (this.state.gridView && cookie.loadAll().deployment_mode === 'offline') {
                annotationsDiv = getAnnotationsInGridView(currentAnnotations, this.state.selectedAnnotationId, this.props.zoomScale, 
                    this.props.slide, this.onSelectAnnotationFromList, this.onDeleteAnnotation, this.doRefreshAnnotationsFromBackend, 
                    this.props.viewerSettingData, this.state.imgsPerColInGridView, this.onChangeImgsPerColInGridView);
            } else {
                annotationsDiv = getAnnotationsInListView(currentAnnotations, this.props.slide, this.state.selectedAnnotationId, this.onSelectAnnotationFromList, 
                    this.props.viewerSettingData, this.props.zoomScale, this.onDeleteAnnotation, this.doRefreshAnnotationsFromBackend);
            }
        } else {
            annotationsDiv = this.props.annotationsViewCreator(currentAnnotations, this.state.selectedAnnotationId, this.onSelectAnnotationFromList,
                    this.onDeleteAnnotation, this.doRefreshAnnotationsFromBackend);
        }

        return (
            <Row className={(this.props.extraClass === undefined ? "" : this.props.extraClass) + " annotations-app-parent overlayed-component app-parent"} id="annotations-app-parent-id">
                <Col>
                    <Row>
                    {
                        drawingTools.map((drawingTool, index) => {
                            return <Col key={index} span={colSpan}>
                                {drawingTool}
                            </Col>
                        })
                    }
                    </Row>
                    <Divider /> 
                    <Spin spinning={this.state.isFetching} tip={this.state.busyMessage}>
                        {this.props.showOptions ? 
                            <Row>
                                {cookie.loadAll().deployment_mode === 'offline' ? 
                                <Radio.Group size="small" className="grid-switch" value={this.state.gridView ? 1 : 0} onChange={this.switchGridView}>
                                    <Radio.Button className="grid-switch-radio" value={0}>List</Radio.Button>
                                    <Radio.Button className="grid-switch-radio" value={1}>Grid</Radio.Button>
                                </Radio.Group> : undefined}
                                <Switch 
                                    className="continuous-mode-switch"
                                    defaultChecked={false} 
                                    size="small"
                                    checked={this.state.continuousMode}
                                    onChange={this.switchContinuousMode}
                                />
                                <span className="continuous-mode-text unselectable">Continuous Drawing Mode</span> 
                            </Row> : undefined }
                        <Row>
                            {annotationsDiv}
                        </Row>
                    </Spin>
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        urlState: state.viewerUrlReducer,
        viewerSettingData: state.viewerSettingReducer,
    }
}

export default connect(mapStateToProps)(AbstractAnnotator);
